<template>
  <el-dialog width="800px" title="图标" v-model="isvisible">
    <ul class="iconUl">
      <template v-for="icon in iconList" :key="icon">
        <li :class="{ active: choosedIcon === icon }" @click="chooseIcon(icon)">
          <span>
            <el-icon :size="20"><component :is="icon" /></el-icon>
          </span>
          <p>{{ icon }}</p>
        </li>
      </template>
    </ul>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="toEmits">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";

import * as IconsModule from "@element-plus/icons-vue";

const emit = defineEmits(["click"]); // 声明触发事件 change

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

defineExpose({ changeVisible });

const toEmits = () => {
  //触发父组件中暴露的click方法并携带数据
  isvisible.value = false;
  console.log("isvisible--", isvisible.value);
  emit("click", choosedIcon);
};

const iconList = ref([]);
const choosedIcon = ref(null);

for (var key in IconsModule) {
  iconList.value.push(IconsModule[key].name);
}
const chooseIcon = (icon) => {
  choosedIcon.value = icon;
};
const closeDialog = () => {
  isvisible.value = false;
};
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 0;
}
.iconUl {
  margin: 0;
  padding: 0;
  text-align: left;
  height: 350px;
  overflow-y: auto;
}
.iconUl li {
  text-align: center;
  list-style: none;
  display: inline-block;
  width: 115px;
  font-size: 12px;
  border: 1px solid #ccc;
  margin: 4px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
}
.iconUl li p {
  padding: 0;
  margin: 0;
}
.active {
  color: red;
}
</style>